import React from 'react'
import './Main.css'

const Main: React.FC = () => {
  return (
    <section id="home" className="main">
      <div className="main-background"></div>
      <div className="container">
        <div className="main-content fade-in">
          <h1 className="main-title">
            Welcome to <span className="highlight">Lazy Load Studios</span>
          </h1>
          <p className="main-subtitle">
            An up-and-coming game studio crafting innovative gaming experiences.
            Led by Demortes' creative vision, we're developing unique games and miscellaneous releases
            that push the boundaries of interactive entertainment.
          </p>
          <div className="main-actions">
            <button className="cta-button primary">
              Explore Our Projects
            </button>
            <button className="cta-button secondary">
              About the Studio
            </button>
          </div>
          <div className="coming-soon">
            🎮 Exciting projects launching soon!
          </div>
        </div>
      </div>
    </section>
  )
}

export default Main